import { Component, OnInit } from '@angular/core';
import { Dashboard } from "src/shared/models/dashboard.model";
import { DashboardService } from '../../dashboard.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { TemplateListModalComponent } from '../../modals/template-list-modal/template-list-modal.component';

@Component({
    selector: 'cv-cxone-empty-workspace',
    templateUrl: './cxone-empty-workspace.component.html',
    styleUrls: ['./cxone-empty-workspace.component.scss']
})
export class CxoneEmptyWorkspaceComponent implements OnInit {

    modalRef: NgbModalRef = null;

    constructor(
        public dashboardService: DashboardService,
        public navigationService: NavigationService,
        public ngbModal: NgbModal,
    ) { }

    ngOnInit(): void {
    }

    //#region New Dashboard
    public async createNewDashboard(dashboard: Dashboard, workspaceKey) {
        const data = {
            dashboardName: '',
            description: '',
            folder: 'CXOne Default',
            key: workspaceKey,
            iscxone: true,
        };
        this.dashboardService.openSaveDashboardModal(data, 'NewDashboard', false).subscribe(newDashboard => {
            if (newDashboard) {
                this.dashboardService.loadExistingDashboardsAndGroups();
            }
        });
    }

    public hasCreatePermission(): boolean {
        return !!this.dashboardService.permissions["launch_cxone_dash"];
    }

    public async openFromTemplate() {
        this.navigationService.showOverlay = true;
        this.modalRef = this.ngbModal.open(TemplateListModalComponent, { size: "from-template", centered: true, scrollable: true, modalDialogClass: 'cx-one-ui' });
        this.modalRef.result.finally(() => this.navigationService.showOverlay = false);
    }
}
